export const selectCurrencies = state => state.multiCurrency.currencies;

export const selectPreferredCurrency = state =>
    state.multiCurrency.preferredCurrency;

export const selectShowCurrencySelection = state =>
    !!(
        state.multiCurrency.enabled &&
        state.multiCurrency.preferredCurrency &&
        state.multiCurrency.currencies &&
        state.multiCurrency.currencies.length > 0
    );
